import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  ViewChildren,
  QueryList,
  OnDestroy,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  IndPhrase,
  CatDocStatusEnum,
  MergeLine,
  CatalogStatusEnum,
  IndElement,
  IndImage,
  CatDocStateTagEnum,
  CatDoc,
  ExtRef,
  ReferenceDocument,
} from 'src/app/shared/models/cat.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import {
  DataElement,
  ReferencePhrase,
  AddInstr,
  PhraseWord,
  CatMatch,
  ProcessRunStatusEnum,
  AssociatedTextPhrase,
  IgnoredWord,
  ConsistencyIssuesToUpdateDto,
  AssociatedImage,
  ReferenceIssue,
  AssociatedImageFinding,
  DrawerDetails,
  ProcessRunStatusResult,
  AnchorResult,
  BoundingBoxAnchorResult,
  CopiedAnchorResult,
  UserAddedAnchorResult
} from 'src/app/shared/models/common';
import { NgRedux } from '@redux/redux-compatibility.service';
import { actionsList, AppState } from 'src/app/shared/redux/store';
import { CatService } from 'src/app/shared/services/cat.service';
import { TreeNode } from 'primeng/api';
import { Popover } from 'primeng/popover';
import { TranslateService } from '@ngx-translate/core';
import { CatPhraseRefComponent } from '../cat-phrase-ref/cat-phrase-ref.component';
import { CatAddInstrComponent } from '../cat-add-instr/cat-add-instr.component';
import { BehaviorSubject, Observable, Subject, forkJoin } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ProcessStatusPollingService } from '@shared/services/process-status-polling.service';
import { GrammarSpellingCheckService } from '@shared/services/grammar-spelling-check.service';
import { AuthService } from '@shared/services/auth.service';
import { CommonService } from '@shared/services/common.service';
import { EmbeddedObjectAnnotation } from '@shared/models/embedded-object-annotation';
import { IssuesFactory } from '@shared/components/issues/factory/issues.factory';
import { ConsistencyIssue, ConsistencyIssueClaim, ConsistencyIssueViewModel } from '@shared/components/issues/factory/model/consistency-issue.models';
import { ComplianceIssue } from '@shared/components/issues/factory/model/compliance-issue.models';
import { FairBalanceIssue } from '@shared/components/issues/factory/model/fair-balance-issue.models';
import { Config } from 'src/app/config';
import { IntegrationService } from '@shared/services/integration.service';
import { getObjectPropValue } from '@shared/utils';
import { ReevalJobService } from '@shared/services/reeval-job.service';
import { ReevalJobTarget } from '@shared/models/reeval-job.model';
import { ClaimToolElement } from '@shared/models/claim-tool-element.model';
import { ClaimToolComponent } from '@shared/components/claim-tool/claim-tool.component';
import { ClaimToolAnchorState, ClaimToolIssueState, ClaimToolReturnStateService } from '@shared/services/claim-tool-return-state.service';

interface ClaimToolReturnState {
  hadUnsavedChanges: boolean;
  baseline: Record<string, unknown>;
  localValues: Record<string, unknown>;
  editPhraseText: string;
  anchors: ClaimToolAnchorState;
  issues: ClaimToolIssueState;
  //catMatchReferenceOriginals: Map<string, string>;
}

@Component({
    selector: 'cat-doc-phrase-details',
    templateUrl: './cat-doc-phrase-details.component.html',
    styleUrls: ['./cat-doc-phrase-details.component.scss'],
    standalone: false
})
export class CatDocPhraseDetailsComponent implements OnInit, OnDestroy {
  @Input() editable: boolean = true;
  @Input() stateTag: CatDocStateTagEnum = CatDocStateTagEnum.PRIME;
  @Input() hasNext: boolean = true;
  @Input() hasPrev: boolean = true;
  @Input() referenceDocuments: ReferenceDocument[] = [];
  @Input() claimToolElement: ClaimToolElement | null = null;
  
  @Output() showClaimToolEmitter = new EventEmitter();
  @Output() showNextIndElementEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() showPrevIndElementEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() hideAnnotation = new EventEmitter();
  @Output() setDisplayDetailsDialogActionsFlag = new EventEmitter<IndElement>();
  @ViewChildren('assocImagesDivs') assocImagesDivs!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('claimTool') claimToolComponent: QueryList<ClaimToolComponent>;
  showClaimToolDialog: boolean = false;
  private claimToolReturnState: ClaimToolReturnState | null = null;
  
  detailsDialogLabel: string;
  refDocToView: ReferenceDocument;
  disableUserActions: boolean = false;
  @Input('mode') set data(mode: 'cat' | 'ind') {
    if (mode == 'cat') {
      this.catModeSw = true;
    } else {
      this.indModeSw = true;
    }

    this.element = this.ngRedux.getState().curCatElement;
    if (this.ngRedux.getState().curCatElement instanceof IndPhrase) {
      this.phrase = this.ngRedux.getState().curCatElement as IndPhrase;
    } else if (this.ngRedux.getState().curCatElement instanceof IndImage) {
      this.image = this.ngRedux.getState().curCatElement as IndImage;
      this.initialFigureCategory = this.image.figureCategory;
      this.currentFigureCategory = this.image.figureCategory;
    }
  }
  element: IndElement;
  phrase: IndPhrase;
  image: IndImage;
  indModeSw: boolean;
  catModeSw: boolean;
  showConsistencyIssuePhrases: boolean = false; 
  hideClaimConsistenciesTable: boolean = true;
  hideFairBalanceIssuesTable: boolean = true;
  hideComplianceIssuesTable: boolean = true;
  hideReferences: Boolean = new Boolean(true);
  hideFootnotes: Boolean = new Boolean(true);
  hideAssociatedText: Boolean = new Boolean(true);
  hideAssociatedImages = new BehaviorSubject<boolean>(true);
  hideAssociatedTables = new BehaviorSubject<boolean>(true);
  hideSuggestedReferences = new BehaviorSubject<boolean>(true);
  hasReferencesIssues: boolean = false;
  hasAssociatedTextIssues: boolean = false;
  hasAssociatedImageIssues: boolean = false;
  hasAssociatedTablesIssues: boolean = false;
  drawerDetails: DrawerDetails;

  @Output() onClose = new EventEmitter();
  @Output() onStatusChange = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  @Input() editModeSw: boolean;
  @Input() displayEntryDocs: boolean = false;
  @Output() onUpdateSpellingIssues = new EventEmitter();

  @ViewChild('opTypes') typesOverlay: Popover;

  @ViewChildren(CatPhraseRefComponent)
  refComponents: QueryList<CatPhraseRefComponent>;

  @ViewChildren(CatAddInstrComponent)
  instrComponents: QueryList<CatAddInstrComponent>;

  loading: boolean;
  altLoading: boolean;
  phraseStatusOptions: DataElement[] = [];
  displayTypeEditBtn: boolean;
  displayPhraseEditBtn: boolean;
  displayDocsSw: boolean;
  selectedPhraseType: TreeNode;
  catPhraseTypesTree: TreeNode[];
  editPhraseText: string;
  selectedLines: MergeLine[]; // listbox component model
  selectedLinesInternalModel: MergeLine[]; // internal model for manipulation in event handlers
  displayRefOptions: boolean;
  showAddContextDropdown: {
    value: boolean
  } = {
    value: false
  };
  displayAssocTextOptions: boolean;
  editPhraseTextWords: PhraseWord[];
  showIssuesOnFullMatchEnabled: boolean;
  wordsToWhitelist: IgnoredWord[] = [];
  processStatusCheckIntervalMillis = 1000;
  destroy$ = new Subject();

  currEmbeddedObjectAnnotation: EmbeddedObjectAnnotation;
  initialFigureCategory: any = null;
  currentFigureCategory: any = null;

  get extSw(): boolean {
    return (
      this.ngRedux.getState().curCat && this.ngRedux.getState().curCat.extSw
    );
  }

  get inCatEditable(): boolean {
    if (this.indModeSw) {
      return true;
    } else {
      return this.phrase && this.phrase.manualSrcSw;
    }
  }

  get curCatDoc(): CatDoc {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDoc
      : this.ngRedux.getState().curCatDocStateSec.curCatDoc;
  }

  get curCatDocPageNum(): number {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDocPageNum
      : this.ngRedux.getState().curCatDocStateSec.curCatDocPageNum;
  }

  get catEntryStatusList(): DataElement[] {
    return this.ngRedux.getState().catEntryStatusList;
  }

  get figureSubTypeList(): DataElement[] {
    if (!this.element.figureType) return [];
    return this.ngRedux
      .getState()
      .figureTypeList.find((e) => e.id == this.element.figureType).children;
  }

  get notPotentialNew(): boolean {
    let similarityEvent = this.getSimilarityEvent();
    return similarityEvent && similarityEvent != 'POTENTIAL_NEW';
  }

  getSimilarityEvent() {
    let similarityEvent;
    if (this.phrase) {
      similarityEvent = this.phrase.phraseSimilarityEvent;
    } else if (this.image) {
      similarityEvent = this.image.imageSimilarityEvent;
    }
    return similarityEvent;
  }

  get grammarSpellingIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.showIssuesOnFullMatchEnabled && similarityEvent && similarityEvent == 'FULL_MATCH') {
      return [];
    }
    return this.phrase.grammarSpellingIssues;
  }

  get references() {
      
    return this.phrase && this.phrase.references?.filter(ref => ref.refType !== 'FOOTNOTE' && !ref.isConsistencyGenerated);
  }

  get footnotes() {
    
   return this.phrase && this.phrase.references?.filter(ref => ref.refType == 'FOOTNOTE' && !ref.isConsistencyGenerated);
  }

  get anchorContext() {
    return this.phrase && this.phrase.references?.filter(ref => ref.isConsistencyGenerated);
  }

  get catMatchAnchorContext(): ReferencePhrase[] {
    if (this.catMatches.length > 0) {
      let currCatMatch = this.catMatches[this.currentIndex];
      return currCatMatch.catPhrase.references?.filter(ref => ref.isConsistencyGenerated);
    }
    return [];
  }


  get images() {
      
    return this.phrase && this.phrase.associatedImages?.filter(associatedImage => associatedImage.type !== 'TABLE');

  }
  get tables() {
    return this.phrase && this.phrase.associatedImages?.filter(associatedImage => associatedImage.type === 'TABLE');
  }
  hasReferencesIssue(references: ReferencePhrase[], isFootnote: boolean = false) {

    if (this.phrase == undefined) {
      return false;
    }
    
    if (this.catMatches.length == 0) {
      return false;
    }

    if (!isFootnote) {
      for (let anchorPhrase of this.catMatchAnchorContext) {
        if (this.getMissingCatMatchAnchorContext(anchorPhrase)) {
          return true;
        }
      }
    }

    let currCatPhraseId = this.catMatches[this.currentIndex]?.catPhrase?.phraseId;
    
    if (this.getMissingReferenceIssue(currCatPhraseId, isFootnote).length > 0) {
      
      return true;
    }
    if (references == undefined) {
        return false;
    }
      // footnotes have reference issues
      for (let refPhrase of references) { 

        if (this.getReferenceIssue(currCatPhraseId, refPhrase.refPhraseId)) {
          
          return true;
        }
      }
      return false;  
  }

  hasAssociatedImagesIssue(associatedImages: AssociatedImage[], findTables: boolean = false): boolean{
    
    // check consistency issues
    if (associatedImages) {
      for (let assocImage of associatedImages) {
        if (assocImage.consistencyIssues && assocImage.consistencyIssues.length > 0 ) {
          return true;
        }
      }
  }
    if (this.catMatches.length == 0) {
      return false;
    }

    let currCatPhraseId = this.catMatches[this.currentIndex]?.catPhrase?.phraseId;
    let missingAssociateImageFindings = this.getMissingAssocImageFinding(currCatPhraseId, findTables);

    if (missingAssociateImageFindings.length > 0) {
        return true;
    }
    if (associatedImages == undefined) {  
      return false;
    }
    for (let assocImage of associatedImages) {

      let foundAssociatedImage = this.getAssociatedImageFinding(currCatPhraseId, assocImage.assocImageId);

      if (foundAssociatedImage) {
        if (foundAssociatedImage.assocImageFinding !== 'FULL_MATCH') {
          return true; 
        }
      }
      
    }
    return false;

  }

  hasAssociatedTextIssue(): boolean {

    if (this.catMatches.length == 0) {
      
      return false;
    }

    let catPhraseId = this.catMatches[this.currentIndex]?.catPhrase?.phraseId;
    let missingAssocTextFinding = this.getMissingAssocTextFinding(catPhraseId);
    
    if (missingAssocTextFinding.length > 0) {
      
      return true;
    }
    if (this.phrase.associatedText == undefined) { 
        return false;
    }

    for (let assocPhrase of this.phrase.associatedText) {
        
      let foundAssociatedTextFinding = this.getAssociatedTextFinding(catPhraseId, assocPhrase.assocPhraseId);
        if (foundAssociatedTextFinding) {
          if (foundAssociatedTextFinding.assocTextFinding !== 'FULL_MATCH') {
            return true;
          }
        }
      }
    
    return false;

  }  

  get referenceIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.showIssuesOnFullMatchEnabled && similarityEvent && similarityEvent == 'FULL_MATCH') {
      return [];
    }
    return this.phrase.referenceIssues;
  }

  get isExpanded(): boolean {
    return this.ngRedux.getState().indDocDetailsExpanded;
  }

  set isExpanded(isExpanded: boolean) {
    this.ngRedux.getState().indDocDetailsExpanded = isExpanded;
  }

  get isFullMatch(): boolean {
    let similarityEvent = this.getSimilarityEvent();
    return similarityEvent == 'FULL_MATCH';
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private grammarSpellingService: GrammarSpellingCheckService,
    private authService: AuthService,
    private commonService: CommonService,
    private issueFactory: IssuesFactory,
    private integrationService: IntegrationService,
    private processStatusPollingService: ProcessStatusPollingService,
    private reevalJobService: ReevalJobService,
    private claimToolReturnStateService: ClaimToolReturnStateService,
    private cdr: ChangeDetectorRef
  ) {
    this.showIssuesOnFullMatchEnabled = this.sharedService.isShowIssuesOnFullMatchEnabled();
  }

  get reevalTarget(): ReevalJobTarget {
    return {
      kind: 'CAT',
      docId: this.element.docId,
      elementId: this.element.elementId,
      isImage: this.image != null,
      stateTag: this.stateTag
    };
  }
  private pendingPageReload = false;

  private get keepOpenAfterSave(): boolean {
    return this.reevalJobService.isAsyncEnabled() && this.indModeSw;
  }

  private flushPendingPageReload(): void {
    if (this.pendingPageReload) {
      this.pendingPageReload = false;
      this.ngRedux.dispatch({ type: actionsList.RELOAD_CAT_DOC_PAGE_REQ, data: false });
    }
  }

  private emitClose(): void {
    this.flushPendingPageReload();
    this.onClose.emit();
  }

  private saveFailed = false;

  private completeSave(): void {
    this.loading = false;
    if (this.keepOpenAfterSave) {
      if (!this.saveFailed) {
        this.saveNewBaseline();
      }
    } else {
      this.onClose.emit();
    }
  }

  private saveNewBaseline(): void {
    const element = this.element;
    element.consistencyIssuesToUpdate = this.issueFactory.createEmptyIssuesPayloadLike(element.consistencyIssuesToUpdate);
    element.consistencyIssuesDirty = false;
    element.isDirtyConsistencyCheckResults = false;
    element.disableConsistencyCheckResultsActions = false;
    if (this.phrase) {
      this.phrase.anchorsPathsToUpdate = null;
      this.phrase.boundingBoxAnchorsToAdd = [];
      this.phrase.copiedAnchors = [];
      this.phrase.deletedReferences = [];
      this.phrase.deletedAssociatedText = [];
    }
    this.wordsToWhitelist = [];
    
    element.saveOriginal();
    this.pendingPageReload = true;
  }

  ngOnDestroy(): void {    
    this.flushPendingPageReload();
    this.hideAnnotation.next();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void 
  {
  /* We don't use edit mode anymore
    if (!this.element.hasId) {
      this.editModeSw = true;
    }
  */
    this.sharedService.checkConsistencyCheckResultsPanelClose?.pipe(takeUntil(this.destroy$)).subscribe(() => {

      this.closeConsistencyCheckResultPanels();
    })
    if (!this.element.isFullyFetched && this.indModeSw) {
      this.loading = true;
      this.catService.getIndElementSingle(this.curCatDoc?.docId || this.element.docId, this.element.elementId, this.image != null, false, this.image ?? this.phrase).pipe(takeUntil(this.destroy$)).subscribe(
        indElement => {
          
          this.loading = false;
          
          let saveSubject = this.element.propagateActionFromParent;
          let parentPhraseId = this.element.parentPhraseId;
          let isParentActionSelected = this.element.isParentActionSelected;
          Object.assign(this.element, indElement);
          this.element.propagateActionFromParent = saveSubject;
          this.element.parentPhraseId = parentPhraseId;
          this.element.isParentActionSelected = isParentActionSelected;
          this.initialize();
          
        },
        error => {
            this.loading = false;
            this.sharedService.showInfoMessage({
              messageKey: 'translate.alert.searchError',
              infoType: 'error'}
            );
        }
      )
    }
    this.initialize();

  }

  /**
   * Loads the data of a finished background re-evaluation into this dialog and its tile. Unsaved
   * edits are discarded first, after the user confirms.
   */
  onReevalRefresh(): void {
    this.reloadAfterReeval();
  }

  private reloadAfterReeval(): void {
    this.loading = true;
    this.reevalJobService.refreshTile(this.reevalTarget, true).subscribe({
      complete: () => {
        if (this.destroy$.isStopped) {
          return;
        }
        this.loading = false;
        this.initialize(false);
      }
    });
  }

  initialize(saveOriginal: boolean = true) {
    if (saveOriginal) {
      this.element.saveOriginal();
    }
    if (this.phrase) {
      this.editPhraseText = this.phrase.phraseText;
      this.editPhraseTextWords = this.phrase.phraseWords;
      this.initMergeOptions();
    }
    this.initCatTypesTree();

    let actions = [];
    if (this.phrase) {
      actions = this.phrase.phraseActions;
    } else if (this.image) {
      actions = this.image.imageActions;
    }
    // show all actions on old docs
    let isNewRuleDoc = !!this.getSimilarityEvent();
    if (isNewRuleDoc) {
      this.phraseStatusOptions =
      this.sharedService.getCatPhraseUpdStatusOptions().filter(
        s => {
          return actions.indexOf(s.id) >= 0;
        }
      );
    } else {
      this.phraseStatusOptions = this.sharedService.getCatPhraseUpdStatusOptions();
    }
    this.setDisplayDetailsDialogActionsFlag.emit(this.element);
    const uiConfig = this.ngRedux.getState().uiConfig;
    if (uiConfig) {

      const user_action_buttons_enabled_when_dirty = getObjectPropValue(uiConfig, 'rule_details_config.user_action_buttons_enabled_when_dirty');
      if (user_action_buttons_enabled_when_dirty != undefined) {

        this.disableUserActions = !user_action_buttons_enabled_when_dirty;
      }
    }
  }

  closeConsistencyCheckResultPanels() {

    if (this.disableUserActions) {

        this.showAddContextDropdown.value = false;
    }  
    
  }

hasPhraseDirty(): boolean {
  return (
    this.element.isDirty() ||
    (this.phrase && this.editPhraseText !== this.phrase.phraseText)
  );
}
isDirty(): boolean {
  return (
    this.element.isDirty() ||
    (this.phrase && this.editPhraseText !== this.phrase.phraseText) ||
    this.isAltDirty()
  );
}

  isAltDirty(): boolean {
    return this.currentFigureCategory !== this.initialFigureCategory;
  }

private saveAltIfNeededAndContinue(next: () => void): void {
  if (!this.image || !this.isAltDirty()) {
    next();
    return;
  }

  this.altLoading = true;
  this.image.figureCategory = this.currentFigureCategory;

  this.commonService
    .updateImageCategory(
      this.image.docId,
      this.image.imageId,
      this.currentFigureCategory,
      false
    )
    .subscribe({
      next: () => {
        this.initialFigureCategory = this.currentFigureCategory;
        this.altLoading = false;
        next();
      },
      error: err => {
        console.error('Failed to update image category', err);
        this.image.figureCategory = this.initialFigureCategory;
        this.altLoading = false;
        next(); 
      }
    });
}

  discardAltChanges(): void {
    this.currentFigureCategory = this.initialFigureCategory;
  } 
  
  validateAltBeforeSave(): boolean {
    return true; // implementiraj
  }


  hasWhitelistedWords() {
    return this.wordsToWhitelist.length > 0;
  }
  viewPageAndRef(embeddedObjectAnnotation: EmbeddedObjectAnnotation) {
    this.currEmbeddedObjectAnnotation = embeddedObjectAnnotation;
    this.showConsistencyIssuePhrases = true;
  }

  initMergeOptions() {
    if (this.phrase.mergeOptions) {
      this.selectedLines = this.phrase.mergeOptions.filter((m) => m.inUseSw);
      this.selectedLinesInternalModel = this.phrase.mergeOptions.filter((m) => m.inUseSw);
      this.phrase.mergeOptions.forEach((p) => {
        p.displayWordsSw = p.inUseSw && p.phraseWords.some((w) => !w.checked);
      });
    }
  }

  initCatTypesTree() {
    if (!this.ngRedux.getState().catPhraseTypeModel) {
      this.catPhraseTypesTree = [];
    } else if (this.element.typeCode && this.element.subTypeCode) {
      this.catPhraseTypesTree = this.ngRedux
        .getState()
        .catPhraseTypeModel.getTreeBySelectedType(
          this.element.typeCode,
          this.element.subTypeCode
        );
      this.selectedPhraseType = this.ngRedux
        .getState()
        .catPhraseTypeModel.getSubTypeNode(
          this.catPhraseTypesTree,
          this.element.typeCode,
          this.element.subTypeCode
        );
    } else {
      this.catPhraseTypesTree =
        this.ngRedux.getState().catPhraseTypeModel.treeTypesForInput;
    }
  }

  close() {
    if (this.isDirty() || this.hasWhitelistedWords()) {
      let validationStr = this.translateService.instant(
        'translate.cat.discardEditChanges'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.discardChanges();
          this.emitClose();
        },
      });
    } else {
      this.emitClose();
    }
  }

  onElementStatusChange() {
    if (this.phrase && this.catMatches.length > 0 && this.getSimilarityEvent()) {
      if (this.element.userStatus?.value) {
        this.phrase.contextCatPhraseId = this.catMatches[this.currentIndex].catPhrase.phraseId;
      } else {
        this.phrase.contextCatPhraseId = null;
      }
    }
    this.onStatusChange.emit();
  }

  addReference() {
    if (this.catModeSw) {
      this.phrase.references.push(new ReferencePhrase());
    } else {
      this.displayRefOptions = true;
    }
  }

  toggleAddContextDropdown() {
    this.showAddContextDropdown.value = !this.showAddContextDropdown.value;

  }




  addAssociatedText() {
    if (this.indModeSw) {
      this.displayAssocTextOptions = true;
    }
  }

  addInstr() {
    this.element.addInstr.push(new AddInstr());
  }

  onTypeSelected(event: any) {
    this.element.typeCode = this.selectedPhraseType.parent.key;
    this.element.typeDescr = this.selectedPhraseType.parent.label;
    this.element.subTypeCode = this.selectedPhraseType.key;
    this.element.subTypeDescr = this.selectedPhraseType.label;
    this.initCatTypesTree();
    if (this.typesOverlay) {
      this.typesOverlay.hide();
    }
  }

  onSaveClickedPreProcessing() {

    if (this.phrase && this.phrase.boundingBoxAnchorsToAdd && this.phrase.boundingBoxAnchorsToAdd.length > 0) {

        this.loading = true;
        this.commonService.createBoundingBoxesAnchors(this.phrase.boundingBoxAnchorsToAdd, this.curCatDoc.catVersionId, this.phrase).subscribe({
          next: () => {

            this.onSaveClicked();
            

          },
          error: err => {
            // show error stop loading
            this.loading = false;

          }
        }
        );
    } else {

      this.onSaveClicked();
      
    }

  }

  onSaveClicked() {
    
    // send request when response is retrieved 
    // call on save clickedProcessing
    this.loading = true;
    this.saveFailed = false;
    const requests: Observable<any>[] = [];

    let consistencyIssuesToUpdate: ConsistencyIssuesToUpdateDto = null;

    if (this.phrase != null) {
      
      consistencyIssuesToUpdate = this.phrase.consistencyIssuesToUpdate;
      this.commonService.setRefConsistencyParamIfAllAnchorsRemoved(this.phrase);

    } else if (this.image != null) {
      
      consistencyIssuesToUpdate = this.image.consistencyIssuesToUpdate;
    }
    if (this.phrase.anchorsPathsToUpdate != null && this.phrase.anchorsPathsToUpdate.anchors.length > 0) {

      requests.push(this.commonService.updateAnchors(this.ngRedux.getState().curCat.catVersionId, this.phrase));
    }
    if (consistencyIssuesToUpdate != null && this.commonService.hasIssuesToUpdate(consistencyIssuesToUpdate)) {

      if (this.reevalJobService.isAsyncEnabled() && this.indModeSw) {
        const target = this.reevalTarget;
        requests.push(this.commonService.startConsistencyIssuesRun(consistencyIssuesToUpdate)
          .pipe(tap((runNum: number) => this.reevalJobService.startJob(runNum, target))));
      } else {
        requests.push(this.updateConsistencyIssuesAndSave(consistencyIssuesToUpdate));
      }
    }

    if (requests.length > 0) {
      forkJoin(requests).subscribe({          
          next: () =>  this.onSaveClickedProcessing(),          
          error: () => {
            this.saveFailed = true;
            this.onSaveClickedProcessing();
          }
        });
    } else {
        
      this.onSaveClickedProcessing();
    }
  }
  updateConsistencyIssuesAndSave(consistencyIssuesToUpdate: ConsistencyIssuesToUpdateDto) {
    return this.commonService.startConsistencyIssuesRun(consistencyIssuesToUpdate).pipe(
      switchMap((runNum: number) => this.processStatusPollingService.pollUntilDone(runNum, { until$: this.destroy$ }))
    );
  }
  onSaveClickedProcessing() {
  this.loading = true;

  if (this.hasWhitelistedWords()) {
    this.processWhitelistedWords().subscribe(
      _ => {
        this.commonService
          .addAlgRunHead({ doc_id: this.phrase.docId, run_type: 'IND_SPELLING_LIGHT' })
          .subscribe(
            runNum => {
              const words: string[] = this.wordsToWhitelist.map(w => w.word);

              this.grammarSpellingService
                .updateSpellingLight(runNum, words)
                .subscribe(_ => {
                  let timer = setInterval(() => {
                    this.authService.getProcessStatus(runNum).subscribe(
                      data => {
                        if (
                          data.status === ProcessRunStatusEnum.FINISHED ||
                          data.status === ProcessRunStatusEnum.FAILED
                        ) {
                          clearInterval(timer);

                          this.onUpdateSpellingIssues.emit();

                          if (this.hasPhraseDirty()) {
                            this.savePhraseChanges(() => this.finishSave());
                          } else {
                            this.saveAltIfNeededAndContinue(() => this.completeSave());
                          }
                        }
                      },
                      _ => clearInterval(timer)
                    );
                  }, this.processStatusCheckIntervalMillis);
                });
            },
            _ => (this.loading = false)
          );
      },
      _ => (this.loading = false)
    );
  } else {
    if (this.hasPhraseDirty()) {
      this.savePhraseChanges(() => this.finishSave());
    } else {
      this.saveAltIfNeededAndContinue(() => this.completeSave());
    }
  }
}

private finishSave(): void {
  this.saveAltIfNeededAndContinue(() => this.completeSave());
}

  savePhraseChanges(callback: () => void) {
    if (this.indModeSw) {
      this.saveChangesIndMode(callback);
    } else {
      this.saveChangesCatMode(callback);
    }
  }

  saveChangesIndMode(callback: () => void) {
    if (!this.element.hasId) {
      this.catService
        .createIndDocPhrase(this.phrase, this.curCatDoc, this.curCatDocPageNum)
        .subscribe({
          next: () => {
            callback();
          },
          error: err => {
            console.error(err);
            this.saveFailed = true;
            callback();
          }
        });
      return;
    }

    // UPDATE
    let txtUpdated = false;
    let refUpdated = false;
    let assocTextUpdated = false;
    let consistencyIssueUpdated = false;

    if (this.phrase) {
      txtUpdated = this.phrase.phraseText !== this.editPhraseText;
      refUpdated =
        JSON.stringify(this.phrase.references) !==
        JSON.stringify((JSON.parse(this.phrase.original) as IndPhrase).references);

      assocTextUpdated =
        JSON.stringify(this.phrase.associatedText) !==
        JSON.stringify((JSON.parse(this.phrase.original) as IndPhrase).associatedText);

      consistencyIssueUpdated =
        JSON.stringify(this.phrase.consistencyIssues) !==
        JSON.stringify((JSON.parse(this.phrase.original) as IndPhrase).consistencyIssues);
    }

    if (this.image) {
      consistencyIssueUpdated =
        JSON.stringify(this.image.consistencyIssues) !==
        JSON.stringify((JSON.parse(this.image.original) as IndImage).consistencyIssues);
    }

    this.catService.updIndDocPhrase(this.element, false, this.keepOpenAfterSave).subscribe({
      next: (linesUpdSw) => {
        this.element.saveOriginal();
        this.setInitialEditMode();
        this.instrComponents.forEach(c => (c.editMode = false));
        this.refComponents.forEach(c => (c.editMode = false));

        if (txtUpdated || refUpdated || assocTextUpdated || consistencyIssueUpdated) {
          if (!this.keepOpenAfterSave) {
            this.ngRedux.dispatch({
              type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
              data: linesUpdSw,
            });
          }
        }

        if (txtUpdated) {
          this.ngRedux.dispatch({
            type: actionsList.REANNOTATE_CAT_DOC_REQ,
            data: linesUpdSw,
          });
        }

        callback();
      },
      error: err => {
        console.error(err);
        this.saveFailed = true;
        callback();
      }
    });
  }


  saveChangesCatMode(callback: () => void) {
  // CREATE
  if (!this.element.hasId) {
    this.phrase.phraseText = this.editPhraseText;
    this.catService.createCatEntry(this.phrase).subscribe({
      next: () => {
        callback();
      },
      error: err => {
        console.error(err);
        callback();
      }
    });
    return;
  }

  let editCall: Observable<any>;
  if (this.element instanceof IndPhrase) {
    editCall = this.catService.editCatPhrase(this.element.phraseId);
  } else {
    editCall = this.catService.editCatImage(this.element.elementId);
  }

  editCall.subscribe({
    next: () => {
      this.catService.updCatEntry(this.element).subscribe({
        next: () => {
          this.element.saveOriginal();
          this.setInitialEditMode();
          this.instrComponents.forEach(c => (c.editMode = false));
          this.refComponents.forEach(c => (c.editMode = false));
          callback();
        },
        error: err => {
          console.error(err);
          callback();
        }
      });
    },
    error: err => {
      console.error(err);
      callback();
    }
  });
}


  processWhitelistedWords(): Observable<IgnoredWord[]> {
    const catId = this.ngRedux.getState().curCat.catId;
    return this.grammarSpellingService.addCatSpellingCheckIgnoredWords(catId, this.wordsToWhitelist);
  }

  setInitialEditMode() {
    if (this.phrase) {
      this.editPhraseText = this.phrase.phraseText;
      this.editPhraseTextWords = this.phrase.phraseWords;
      this.initMergeOptions();
    }

    this.editModeSw = false;
  }

  discardChanges() {
    this.element.restoreOriginal();

    this.setInitialEditMode();
    this.wordsToWhitelist = [];
    if (this.phrase) {
    this.phrase.grammarSpellingIssues?.forEach(i => {i.isWhitelisted = false; i.isWhitelistedGlobally = false;});
    let fairBalanceIssues: FairBalanceIssue[] = [];
    
      this.phrase.fairBalanceIssues?.forEach((issue: FairBalanceIssue) => {
        fairBalanceIssues.push(this.issueFactory.createFairBalanceIssue(issue, issue['embeddedObjectAnnotation']));
      });
      this.phrase.fairBalanceIssues = fairBalanceIssues;

    let complianceIssues: ComplianceIssue[] = [];
    
      this.phrase.complianceIssues?.forEach((issue: ComplianceIssue) => {
        complianceIssues.push(this.issueFactory.createComplianceIssue(issue));
      });
      this.phrase.complianceIssues = complianceIssues;
      this.phrase.associatedImages?.forEach(associatedImage => {
        
        let consistencyIssues = [];
        associatedImage.hideConsistencyIssuesTable = false;
        associatedImage.consistencyIssues?.forEach(consistencyIssue => {
          consistencyIssues.push(this.issueFactory.createConsistencyIssue(consistencyIssue, consistencyIssue['embeddedObjectAnnotation'], false, consistencyIssue['consistencyIssueAssocImgParent']));
        })
        associatedImage.consistencyIssues = consistencyIssues;
    })
    }
    let consistencyIssues: ConsistencyIssue[] = [];
    this.element.consistencyIssues?.forEach((consistencyIssue: ConsistencyIssue) => {
      consistencyIssues.push(this.issueFactory.createConsistencyIssue(consistencyIssue, consistencyIssue['embeddedObjectAnnotation'], this.image != null));
    })
    this.element.consistencyIssues = consistencyIssues;
    this.discardAltChanges();
    this.catService.recalculateElementSections(this.element);
  }

  onMergeOptionsClicked(event: any) {
    let line = event.option as MergeLine;
    console.log(line);

    if (this.selectedLinesInternalModel.includes(line)) {
      this.selectedLinesInternalModel.splice(this.selectedLinesInternalModel.indexOf(line), 1);
    } else {
      this.selectedLinesInternalModel.push(line);
    }

    line.phraseWords.forEach(
      (w) => (w.checked = this.selectedLinesInternalModel.includes(line))
    );
    this.updateEditPhraseTxt();
  }

  onMergeWordChange(line: MergeLine) {
    if (
      line.phraseWords.some((w) => w.checked) &&
      !this.selectedLines.includes(line)
    ) {
      this.selectedLines.push(line);
      this.selectedLinesInternalModel.push(line);
    }
    if (
      line.phraseWords.every((w) => !w.checked) &&
      this.selectedLines.includes(line)
    ) {
      this.selectedLines.splice(this.selectedLines.indexOf(line), 1);
      this.selectedLinesInternalModel.splice(this.selectedLines.indexOf(line), 1);
    }
    this.updateEditPhraseTxt();
  }

  updateEditPhraseTxt() {
    this.editPhraseText = this.selectedLinesInternalModel
      .srp_sortByKey('id')
      .map((m: MergeLine) =>
        m.phraseWords
          .filter((w) => w.checked)
          .map((w) => w.text)
          .join(' ')
      )
      .join(' ');

    this.phrase.mergeOptions.forEach((l) => {
      l.inUseSw = this.selectedLinesInternalModel.indexOf(l) !== -1;
    });

    this.editPhraseTextWords = [];
    this.selectedLinesInternalModel.forEach((o) => {
      this.editPhraseTextWords.push(...o.phraseWords.filter((w) => w.checked));
    });
  }

  onDeleteRef(ref: ReferencePhrase) {
    ref.deleteSw = true;
    this.phrase.deletedReferences.push(ref);
    this.phrase.references.splice(this.phrase.references.indexOf(ref), 1);
  }

  undoPhraseEdit() {
    this.editPhraseText = this.phrase.phraseText;
    this.editPhraseTextWords = this.phrase.phraseWords;
    this.editModeSw = false;
  }

  onDeleteInstr(instr: AddInstr) {
    this.element.addInstr.splice(this.element.addInstr.indexOf(instr), 1);
  }

  onDeleteClicked() {
    if (this.indModeSw) {
      this.loading = true;
      this.catService.updIndDocPhrase(this.element, true).subscribe(
        (data) => {
          this.loading = false;
          this.onDelete.emit();
        },
        (err) => (this.loading = false)
      );
    } else {
      let validationStr = this.translateService.instant(
        'translate.cat.deleteEntry'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.loading = true;
          
          let deleteCall: Observable<any>;
          if (this.element instanceof IndPhrase) {
            deleteCall = this.catService.deleteCatPhrase(this.element.phraseId);
          } else {
            deleteCall = this.catService.deleteCatImage(this.element.elementId);
          }

          deleteCall.subscribe(
            (data) => {
              this.catService.updCatEntry(this.element, true).subscribe(
                (data) => {
                  this.loading = false;
                  this.onDelete.emit();
                },
                (err) => (this.loading = false)
              );
            },
            (err) => (this.loading = false)
          );
        },
      });
    }
  }

  validateBeforeSave(): boolean {
    if (this.phrase && !this.editPhraseText) {
      return false;
    } else {
      return true;
    }
  }

  onPhraseRefAdd(phrase: IndPhrase) {
    let ref = new ReferencePhrase();
    ref.refPhraseId = phrase.phraseId;
    ref.refPhraseText = phrase.phraseText;
    ref.newSw = true;
    ref.pointerWordId =
      this.phrase.phraseWords[this.phrase.phraseWords.length - 1].id;
    this.phrase.references.push(ref);
    this.displayRefOptions = false;
  }

  onAssociatedTextAdd(phrase: IndPhrase) {
    let assocPhrase = new AssociatedTextPhrase();
    assocPhrase.assocPhraseId = phrase.phraseId;
    assocPhrase.phraseId = this.phrase.phraseId;
    assocPhrase.assocPhraseText = phrase.phraseText;
    assocPhrase.newSw = true;
    this.phrase.associatedText.push(assocPhrase);
    this.displayAssocTextOptions = false;
  }

  onPhraseRefRemove(phrase: IndPhrase) {
    let idx = this.phrase.references.findIndex(
      (r) => r.refPhraseId == phrase.phraseId
    );
    if (idx != -1) {
      this.phrase.references.splice(idx, 1);
    }
  }

  onAssociatedTextRemove(phrase: IndPhrase) {
    let idx = this.phrase.associatedText.findIndex(
      (r) => r.assocPhraseId == phrase.phraseId
    );
    if (idx != -1) {
      const removedAssocText = this.phrase.associatedText[idx];
      removedAssocText.deleteSw = true;
      this.phrase.deletedAssociatedText.push(removedAssocText);
      this.phrase.associatedText.splice(idx, 1);
    }
  }

  removeExtRef(extRef: ExtRef) {
    this.catService.updExtRefPointer(extRef, true).subscribe(
      (data) => {
        this.phrase.extRefs.splice(this.phrase.extRefs.indexOf(extRef), 1);
        this.ngRedux.dispatch({
          type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
          data: false,
        });
      },
      (err) => {}
    );
  }

  currentIndex: number = 0;

  getCurrentMatch(): CatMatch {
    return this.catMatches[this.currentIndex];
  }

  prevMatch() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  nextMatch() {
    if (this.currentIndex < this.catMatches.length - 1) {
      this.currentIndex++;
    }
  }

  get catMatches(): CatMatch[] {
    return this.element?.catMatches || [];
  }

  getCurrentSimilarity(): number {
    return this.catMatches[this.currentIndex]?.similarityPct || 0;
  }

  getPrevSimilarity(): number {
    return this.catMatches[this.currentIndex - 1]?.similarityPct || 0;
  }

  getNextSimilarity(): number {
    return this.catMatches[this.currentIndex + 1]?.similarityPct || 0;
  }

  getReferenceIssue(phraseId: number, refPhraseId: number): any {
    return this.phrase.referenceIssues?.find(
      issue => 
        (issue.catPhraseId === phraseId && issue.refPhraseId === refPhraseId)
    );
  }

  getAssociatedTextFinding(phraseId: number, assocPhraseId: number): any {
    return this.phrase.assocTextFindings?.sort((a, b) => {
      if (a.similarity > b.similarity) return -1;
      if (a.similarity < b.similarity) return 1;
      return 0;
    })
    .find(issue => 
      (issue.catPhraseId === phraseId && issue.assocPhraseId === assocPhraseId) ||
      (issue.catPhraseId === phraseId && issue.assocTextFinding === 'ADDED_ASSOC_TEXT')
    );
  }

  getAssociatedImageFinding(phraseId: number, assocImageId: number): any {
    return this.phrase.assocImageFindings?.sort((a, b) => {
      if (a.similarity > b.similarity) return -1;
      if (a.similarity < b.similarity) return 1;
      return 0;
    })
    .find(issue => 
      (issue.catPhraseId === phraseId && issue.assocImageId === assocImageId) ||
      (issue.catPhraseId === phraseId && issue.assocImageFinding === 'ADDED_ASSOC_IMAGE')
    );
  }

  getAddedReferenceIssue(phraseId: number): any[] {
    return this.phrase.referenceIssues?.filter(
      issue => issue.catPhraseId === phraseId && issue.refFinding === 'ADDED_REFERENCE'
    ) || [];
  }

  getMissingReferenceIssue(phraseId: number, findFootnotes = false): any[] {
    // ISSUE issue.catRefPhraseId id reference u cataloga
    let missingReferenceIssues = this.phrase && this.phrase.referenceIssues?.filter(
      issue => issue.catPhraseId === phraseId && issue.refFinding === 'MISSING_REFERENCE'
    ) || [];
    return this.getMissingReferenceIssuesWithType(missingReferenceIssues, findFootnotes);
  }

  getMissingReferenceIssuesWithType(missingReferenceIssues: ReferenceIssue[], findFootnotes: boolean) {
    let filteredReferenceIssues = [];
    for (let i=0; i<missingReferenceIssues?.length; i++) {
      
      let currReferenceIssue: ReferenceIssue = missingReferenceIssues[i];
      let foundReference: ReferencePhrase = this.catMatches[this.currentIndex].catPhrase.references?.find(referenceFromCatalog => referenceFromCatalog.refPhraseId == currReferenceIssue.catRefPhraseId);
      if (foundReference) {
        if ((foundReference.refType == 'FOOTNOTE' && findFootnotes) || (foundReference.refType !== 'FOOTNOTE' && !findFootnotes)) {
          
          filteredReferenceIssues.push(currReferenceIssue);
        }
      }
    }

    return filteredReferenceIssues;
  }

  getMissingAssocTextFinding(phraseId: number): any[] {
    let result = this.phrase.assocTextFindings?.filter(
      assocFinding => (assocFinding.catPhraseId === phraseId && assocFinding.assocTextFinding === 'MISSING_ASSOC_TEXT')
    ) || [];

    let usedCatAssocPhraseIds = [];

    for (let assocPhrase of this.phrase.associatedText) {
      const finding = this.getAssociatedTextFinding(phraseId, assocPhrase.assocPhraseId);
      if (finding) {
        usedCatAssocPhraseIds.push(finding.catAssocPhraseId);
      }
    }

    let nonMissingFindings = this.phrase.assocTextFindings
      ?.filter(assocFinding => assocFinding.catPhraseId === phraseId && assocFinding.assocTextFinding !== 'MISSING_ASSOC_TEXT')
      .sort((a, b) => {
        if (a.similarity > b.similarity) return -1;
        if (a.similarity < b.similarity) return 1;
        return 0;
      });

    if (nonMissingFindings) {
      for (let assocFinding of nonMissingFindings) {
        let catAssocId = assocFinding.catAssocPhraseId;
  
        if (usedCatAssocPhraseIds.indexOf(catAssocId) === -1) {
          usedCatAssocPhraseIds.push(catAssocId);
          result.push(assocFinding);
        }
      }
    }

    return result;
  }

  getMissingAssocImageFindingWithType(imageFindings: AssociatedImageFinding[], findTables: boolean = false) {
    let filteredImageFindings = [];

    for (let i=0; i<imageFindings.length; i++) {
      let currImageFinding = imageFindings[i];

      let foundAssociatedImage: AssociatedImage = this.catMatches[this.currentIndex]?.catPhrase?.associatedImages?.find(associatedImage => currImageFinding.catAssocImageId == associatedImage.assocImageId);
      if (foundAssociatedImage) {
        if ((foundAssociatedImage.type == 'TABLE' && findTables) || (foundAssociatedImage.type != 'TABLE' && !findTables)) {
            
          filteredImageFindings.push(currImageFinding);
        }
      } 
    }
    return filteredImageFindings;
  }

  getMissingAssocImageFinding(phraseId: number, findTables: boolean = false): any[] {

    if (this.phrase == undefined) {
      return [];
    }
    let result = this.phrase.assocImageFindings?.filter(
      assocFinding => (assocFinding.catPhraseId === phraseId && assocFinding.assocImageFinding === 'MISSING_ASSOC_IMAGE')
    ) || [];

    let usedCatAssocImageIds = [];

    for (let assocImage of this.phrase.associatedImages) {
      const finding = this.getAssociatedImageFinding(phraseId, assocImage.assocImageId);
      if (finding) {
        usedCatAssocImageIds.push(finding.catAssocImageId);
      }
    }

    let nonMissingFindings = this.phrase.assocImageFindings
      ?.filter(assocFinding => assocFinding.catPhraseId === phraseId && assocFinding.assocImageFinding !== 'MISSING_ASSOC_IMAGE')
      .sort((a, b) => {
        if (a.similarity > b.similarity) return -1;
        if (a.similarity < b.similarity) return 1;
        return 0;
      });

    if (nonMissingFindings) {
      for (let assocFinding of nonMissingFindings) {
        let catAssocId = assocFinding.catAssocImageId;
  
        if (usedCatAssocImageIds.indexOf(catAssocId) === -1) {
          usedCatAssocImageIds.push(catAssocId);
          result.push(assocFinding);
        }
      }
    }

    
    return this.getMissingAssocImageFindingWithType(result, findTables);;
  }

  getCatPhraseReference(catRefPhraseId: number): any {
    return this.element.catMatches[this.currentIndex]?.catPhrase?.references?.find(
      ref => ref.refPhraseId === catRefPhraseId
    );
  }

  getCatPhraseAssocText(catAssocPhraseId: number): any {
    return this.element.catMatches[this.currentIndex]?.catPhrase?.associatedText?.find(
      assoc => assoc.assocPhraseId === catAssocPhraseId
    );
  }

  getCatPhraseAssocImage(catAssocImageId: number): any {
    return this.element.catMatches[this.currentIndex]?.catPhrase?.associatedImages?.find(
      assoc => assoc.assocImageId === catAssocImageId
    );
  }

  onAddToWhitelist(word: IgnoredWord) {
    this.wordsToWhitelist.push(word);
  }

  showPrevIndElement() {
        if (this.isDirty() || this.hasWhitelistedWords()) {
      let validationStr = this.translateService.instant(
        'translate.cat.discardEditChanges'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.discardChanges();
          this.showPrevIndElementEmitter.emit(this.editModeSw);
        },
      });
    } else {
    this.showPrevIndElementEmitter.emit(this.editModeSw);
    }
  }

  showNextIndElement() {
            if (this.isDirty() || this.hasWhitelistedWords()) {
      let validationStr = this.translateService.instant(
        'translate.cat.discardEditChanges'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.discardChanges();
          this.showNextIndElementEmitter.emit(this.editModeSw);
        },
      });
    } else {
      
    this.showNextIndElementEmitter.emit(this.editModeSw);
    }
  }

  showClaimTool() {
    this.claimToolReturnState = this.captureClaimToolReturnState();
    this.showClaimToolDialog = true;
      // init claim tool
    this.showClaimToolEmitter.next();
    
  }

  returnToDetailsFromClaimTool(): void {
    this.showClaimToolDialog = false;
    this.claimToolElement = null;
    this.claimToolReturnState = null;
  }

  onClaimToolSaved(): void {
    if (!this.phrase) {
      this.showClaimToolDialog = false;
      return;
    }

    this.loading = true;
    this.showClaimToolDialog = false;
    this.catService
      .getIndElementSingle(this.phrase.docId || this.curCatDoc.docId, this.element.elementId, false, false, this.phrase)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: refreshedElement => {
          const propagateActionFromParent = this.element.propagateActionFromParent;
          const parentPhraseId = this.element.parentPhraseId;
          const isParentActionSelected = this.element.isParentActionSelected;
          Object.assign(this.element, refreshedElement);
          console.log('Refreshed element after claim-tool save:');
          //console.log(structuredClone(this.element));
          this.element.propagateActionFromParent = propagateActionFromParent;
          this.element.parentPhraseId = parentPhraseId;
          this.element.isParentActionSelected = isParentActionSelected;

          const returnState = this.claimToolReturnState;
          if (returnState?.hadUnsavedChanges) {
            this.element.saveOriginal();
            this.restoreClaimToolReturnState(returnState);
            this.initialize(false);
            this.editPhraseText = returnState.editPhraseText;
          //console.log('Applying return state:');
          //console.log(this.element);
          } else {
            this.initialize();
          }
/*           if (returnState) {
            this.claimToolReturnStateService.restoreCatMatchReferenceOriginals(this.phrase, returnState.catMatchReferenceOriginals);
          } */

          this.claimToolReturnState = null;
          this.claimToolElement = null;
          this.showClaimToolDialog = false;
          this.loading = false;
          //this.cdr.markForCheck();
          this.catService.recalculateElementSections(this.element);
        },
        error: err => {
          console.error('Failed to refresh phrase after claim-tool save', err);
          this.loading = false;
          this.sharedService.showInfoMessage({
            messageKey: 'translate.alert.searchError',
            infoType: 'error'
          });
        }
      });
  }

  private captureClaimToolReturnState(): ClaimToolReturnState | null {
    if (!this.phrase) {
      return null;
    }

    const baseline = this.phrase.original ? JSON.parse(this.phrase.original) as Record<string, unknown> : {};
    const issues = this.claimToolReturnStateService.captureIssues(this.phrase, baseline);
    const hadUnsavedChanges = this.isDirty() || this.claimToolReturnStateService.hasIssueChanges(issues);
    const detailFields: (keyof IndPhrase)[] = [
      'phraseText', 'typeCode', 'typeDescr', 'subTypeCode', 'subTypeDescr',
      'catEntryStatus', 'statusCode', 'statusDescr', 'userStatus',
      'associatedText', 'addInstr', 'referenceIssues', 'assocTextFindings',
      'assocImageFindings', 'phraseOrder', 'isRefSw',
    ];
    const localValues: Record<string, unknown> = {};
    detailFields.forEach(field => {
      const value = this.phrase[field];
      localValues[field] = Array.isArray(value) ? [...value] : value;
    });

    if (!hadUnsavedChanges) {
      return {
        hadUnsavedChanges: false,
        baseline: {},
        localValues,
        editPhraseText: this.editPhraseText,
        anchors: this.claimToolReturnStateService.captureAnchors(this.phrase),
        issues,
        //catMatchReferenceOriginals: this.claimToolReturnStateService.captureCatMatchReferenceOriginals(this.phrase)
      };
    }

    return {
      hadUnsavedChanges: true,
      baseline,
      localValues,
      editPhraseText: this.editPhraseText,
      anchors: this.claimToolReturnStateService.captureAnchors(this.phrase),
      issues
      //catMatchReferenceOriginals: this.claimToolReturnStateService.captureCatMatchReferenceOriginals(this.phrase)
    };
  }

  private restoreClaimToolReturnState(state: ClaimToolReturnState): void {
    this.restoreLocallyChangedDetailFields(state);
    this.claimToolReturnStateService.restoreAnchors(this.phrase, state.anchors);
    this.catService.recalculateElementSections(this.element);
    this.claimToolReturnStateService.restoreIssues(this.phrase, state.issues);
  }

  private restoreLocallyChangedDetailFields(state: ClaimToolReturnState): void {
    const phrase = this.phrase as unknown as Record<string, unknown>;
    Object.entries(state.localValues).forEach(([field, localValue]) => {
      const baselineValue = state.baseline[field];
      if (!this.valuesEqual(localValue, baselineValue) && this.valuesEqual(phrase[field], baselineValue)) {
        phrase[field] = localValue;
      }
    });
  }

  private valuesEqual(first: unknown, second: unknown): boolean {
    return JSON.stringify(first) === JSON.stringify(second);
  }

  toggle() {
  
    if (this.isExpanded) {
      this.drawerDetails = null;
    }
    this.ngRedux.getState().indDocDetailsExpanded = !this.ngRedux.getState().indDocDetailsExpanded;
  }
  revertConsistencyCheckResult(catMatch: CatMatch) {
    
    let i=0;
    let consistencyIssue = null;
    let consistencyIssues = this.element.consistencyIssues;
    for ( ;i<consistencyIssues.length; i++) {
      consistencyIssue = consistencyIssues[i];
      if (consistencyIssue instanceof ConsistencyIssueClaim && consistencyIssue.catPhraseId == catMatch.catPhraseId) {
        break;
      }
    }
    if (i < consistencyIssues.length) {
      
      consistencyIssues.splice(i, 1);
    }
    if (consistencyIssue != null) {
      consistencyIssue.remove(this.element);
    }
  }
  viewConsistencyIssue(consistencyIssueViewModel: ConsistencyIssueViewModel) {
    let correspondingIndex;
    switch(consistencyIssueViewModel.type) {
      case 'reference_consistency_issue': 
        this.currEmbeddedObjectAnnotation = consistencyIssueViewModel.data;
        this.showConsistencyIssuePhrases = true;
        break;
      case 'claim_consistency_issue':
        this.drawerDetails = consistencyIssueViewModel.data?.drawerDetails;
        this.detailsDialogLabel = 'translate.consistencyIssue.details';
        let catPhraseId = consistencyIssueViewModel.data.idToCheck;
        correspondingIndex = this.element.catMatches.findIndex(catMatch => catMatch.catPhraseId == catPhraseId);
        if (correspondingIndex != -1) {
          this.currentIndex = correspondingIndex;
        }
        this.isExpanded = true;
        break;
      case 'cat_image_consistency_issue':
        this.drawerDetails = consistencyIssueViewModel.data?.drawerDetails;
        let imageId = consistencyIssueViewModel.data?.idToCheck;
        this.detailsDialogLabel = 'translate.consistencyIssue.details';
        correspondingIndex = this.element.catMatches.findIndex(catMatch => catMatch.catImage.imageId == imageId);
        if (correspondingIndex != -1) {
          this.currentIndex = correspondingIndex;
        }
        this.isExpanded = true;
        break;
      
      case 'claim_image_consistency_issue':
        this.drawerDetails = consistencyIssueViewModel.data;
        this.detailsDialogLabel = 'translate.consistencyIssue.details';
        this.isExpanded = true;
        break;
      case 'assoc_image_consistency_issue':
            if (consistencyIssueViewModel.data.isTable) {
              this.hideAssociatedTables.next(false);
            } else {
              
              this.hideAssociatedImages.next(false);
            }
            let assocImageId = consistencyIssueViewModel.data.assocImageId;
            let foundAssocImage = this.phrase.associatedImages.find(assocImage => assocImage.assocImageId == assocImageId);
            foundAssocImage.hideConsistencyIssuesTable = false;
          setTimeout(() => {
            const target = this.assocImagesDivs.find(
              el => Number(el.nativeElement.getAttribute('data-id')) === assocImageId
            );
            if (target) {
              target.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              target.nativeElement.classList.add('highlight');
              setTimeout(() => target.nativeElement.classList.remove('highlight'), 2000);
            }
          }, 1000)


    }
  }
  viewFairBalanceIssue(drawerDetails: DrawerDetails) {
    
    this.drawerDetails = drawerDetails; 
    this.detailsDialogLabel = 'translate.fairBalanceIssue.details'; 
    this.isExpanded = true;
  }
  toggleVisibility(hideObj: { toggleVisibility: boolean }) {
      
    hideObj.toggleVisibility = !hideObj.toggleVisibility;
  }
  toggleAssociatedImages(togglingSubject: BehaviorSubject<Boolean>) {
    togglingSubject.next(!togglingSubject.getValue());
  }
  
  getAnchorReferenceIssue(catPhraseId: number, refDocId: number): ReferencePhrase | undefined {
    return this.catMatchAnchorContext?.find(anchor=> anchor.catPhraseId === catPhraseId && anchor.refDocId === refDocId);
  }
  getMissingAnchorReferenceIssue(catPhraseId: number, refDocId: number): ReferenceIssue | undefined {
    return this.referenceIssues?.find(missingAnchor => missingAnchor.catPhraseId === catPhraseId && missingAnchor.refDocId === refDocId && (missingAnchor.refFinding === 'MISSING_ANCHOR_REFERENCE' || missingAnchor.refFinding === 'COPIED_ANCHOR_REFERENCE'));
  }

  get detailsDialogClass(): string {
    if (this.isExpanded) {
      return 'expanded';
    } else {
      return 'collapsed';
    }
  }
  get imageClassName() {

    return 'small-image';
  }

  get associatedImagesClassName() {
    return 'small-image';
  }
  get imageCategoriesForDoc() {
    return this.ngRedux.getState().imageCategoriesForDoc;
  }

  getRefDoc(ref: ReferencePhrase): ReferenceDocument | null {
    for (let refDoc of this.referenceDocuments) {
      if (refDoc.mappedReferenceTexts.includes(ref.refCatMatchTxt)) {
        return refDoc;
      }

      for (let consistencyCheckResult of ref.anchors) {
        if (consistencyCheckResult.refDocId == refDoc.docId) {
          return refDoc;
        }
      }
    }
    return null;
  }
  canViewRefDoc(ref: ReferencePhrase): boolean {
    for (let refDoc of this.referenceDocuments) {
      if (refDoc.mappedReferenceTexts.includes(ref.refCatMatchTxt)) {
        return true;
      }

      for (let consistencyCheckResult of ref.anchors) {
        if (consistencyCheckResult.refDocId == refDoc.docId) {
          return true;
        }
      }
    }
    return false;
  }
  viewRefDoc(ref: ReferencePhrase) {
    for (let refDoc of this.referenceDocuments) {
      if (refDoc.mappedReferenceTexts.includes(ref.refCatMatchTxt)) {
        this.refDocToView = refDoc;
        return;
      }

      for (let consistencyCheckResult of ref.anchors) {
        if (consistencyCheckResult.refDocId == refDoc.docId) {
          this.refDocToView = refDoc;
          return;
        }
      }
    }
  }
  getMissingCatMatchAnchorContext(catMatchAnchorReference: ReferencePhrase): boolean {

      if (!this.anchorContext) {
        return true;
      }
      for (let ref of this.anchorContext) {

          if (catMatchAnchorReference.refDocId == ref.refDocId && this.catMatches[this.currentIndex]?.catPhrase?.phraseId == catMatchAnchorReference.catPhraseId) {
            return false
          }
        }
        if (this.phrase?.referenceIssues) {
          
          for (let refIssue of this.phrase.referenceIssues) {

            if (this.catMatches[this.currentIndex].catPhrase.phraseId == catMatchAnchorReference.catPhraseId && catMatchAnchorReference.refDocId == refIssue.refDocId && refIssue.catPhraseId == catMatchAnchorReference.catPhraseId) {
              
              return false;
            }
          }
        }

        return true;
      
      }
  isAddAnchorsDisabled(): boolean {
    return getObjectPropValue(this.ngRedux.getState().uiConfig, 'anchors.add_anchors_disabled') ?? false;
  }

  getBorderClass(ref: ReferencePhrase): string {

    if (!ref || ref.refType === 'FOOTNOTE') {

      return '';
    }
    if (!ref.newSw) {
      
      return ref.isConsistencyGenerated ? 'border-indicator-anchor' : 'border-indicator-reference';
    } 
    return 'border-indicator-newreference';
  }

  get title() {
    if (this.claimToolComponent?.first) {
      return 'translate.claim.tool';
    }
    return this.phrase
      ? 'translate.cat.phraseDetailsTitle'
      : 'translate.cat.imageDetailsTitle'
  }
  get conditionForDisablingConsistencyCheckResultActions() {

    return this.disableUserActions && this.element.disableConsistencyCheckResultsActions;
  }
  get conditionForDisablingStatusChanges() {
    
    return this.disableUserActions && this.element.isDirtyConsistencyCheckResults;
  }
}
